/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect, useSelector } from 'react-redux'
import { Helmet } from 'react-helmet-async'
import PageTitle from '../../../components/ui/title/PageTitle'
import checkPermission from '../../../helpers/check-permission'
import axiosRequest from '../../../helpers/axios-request.helper'
import convertJsonToUrlParams from '../../../helpers/convert-json-to-url-params'
import axiosErrorHelper from '../../../helpers/axios-error.helper'
import { Button, notification, Tabs } from 'antd'
import AcquisitionProperties from '../../../components/pages/acquisition/data-parser/properties'
import FiltersDrawer from '../../../components/pages/acquisition/filters-drawer'
import { RiFilter3Fill, RiUpload2Fill } from 'react-icons/ri'
import moment from 'moment'
import UploadCSVPropertiesModal from '../../../components/pages/acquisition/data-parser/properties/UploadCSVPropertiesModal'

const tabsStatuses = [
  {
    key: 'all',
    name: 'All Leads',
  },
  {
    key: 'unprocessed',
    name: 'Unprocessed',
  },
  {
    key: 'req_sent',
    name: 'Waiting For Response',
  },
  {
    key: 'not_answered',
    name: 'Not Answered',
  },
  {
    key: 'active',
    name: 'Active',
  },
  {
    key: 'LP_InNegotiations',
    name: 'In Negotiations (LP)',
  },
  {
    key: 'LP_WaitingForApproval',
    name: 'Waiting for Approval (LP)',
  },
  {
    key: 'LP_CallBack',
    name: 'Call Back (LP)',
  },
  {
    key: 'lost',
    name: 'Closed Lost',
  },
  {
    key: 'success',
    name: 'Closed Won',
  },
]

const InvitedUserLeads = () => {
  const users = useSelector((state) => state.users)
  const [loading, setLoading] = useState(true)
  const [activeTab, setActiveTab] = useState('all')
  const [properties, setProperties] = useState({ properties: [], total: 0 })
  const [filters, setFilters] = useState({ page: 1, perPage: 24 })
  const [parserModal, setParserModal] = useState(false)
  const [uploaderModal, setUploaderModal] = useState(false)
  const [filtersDrawer, setFiltersDrawer] = useState(false)

  const getData = (withLoading = true) => {
    if (withLoading) {
      setLoading(true)
    }
    axiosRequest(
      `api/v1/acquisition/data/properties${convertJsonToUrlParams(filters)}${
        activeTab !== 'all' ? `&Status=${activeTab}` : ''
      }&MyLeads=1`,
      'get',
      null,
      true,
    )
      .then((res) => {
        setProperties({
          properties: res.data.data.properties,
          total: res.data.data.total,
        })
      })
      .catch((e) => axiosErrorHelper(e))
      .finally(() => {
        if (withLoading) {
          setLoading(false)
        }
      })
  }
  console.log(users.user)

  useEffect(() => {
    if (activeTab !== 'activityLogs') {
      getData()
    }
    // eslint-disable-next-line
  }, [activeTab, filters])

  return (
    <>
      <Helmet title="My Leads" />
      <PageTitle
        title="My Leads"
        breadcrumbs={[
          { path: '/', name: 'Dashboard' },
          {
            path: '/acquisition/data-parser',
            name: `Acquisition Properties (${properties.total})`,
          },
        ]}
        extraButtons={
          <>
            <Button
              icon={<RiUpload2Fill />}
              className="btn-sm btn-primary fw-500 me-3"
              onClick={() => {
                setUploaderModal(true)
              }}
            >
              Upload CSV
            </Button>
            <Button
              icon={<RiFilter3Fill />}
              className="btn-sm btn-primary fw-500"
              onClick={() => setFiltersDrawer(true)}
            >
              Data Filters
            </Button>
          </>
        }
      />
      <div className="mb-3">
        You have {users.user.acquisition_listings_left || 0} listings to upload.
        Your limit is {users.user.acquisition_listings || 0} per{' '}
        {users.user.acquisition_limit_reset}. Next limit reset will be at{' '}
        {moment(users.user.acquisition_reset_limits_data).format('MM/DD/YYYY')}
      </div>
      <div>
        <Tabs
          activeKey={activeTab}
          onChange={(activeKey) => {
            setFilters({ page: 1, perPage: 24 })
            setActiveTab(activeKey)
          }}
        >
          {tabsStatuses.map((tabStatus) => (
            <Tabs.TabPane tab={tabStatus.name} key={tabStatus.key}>
              <AcquisitionProperties
                getData={getData}
                properties={properties.properties}
                setActiveTab={setActiveTab}
                loading={loading}
                allowAssignManagers={false}
              />
            </Tabs.TabPane>
          ))}
        </Tabs>
      </div>
      <FiltersDrawer
        visible={filtersDrawer}
        setVisibility={setFiltersDrawer}
        filters={filters}
        setFilters={setFilters}
        activeTab={activeTab}
        isLeadsPool={activeTab === 'active'}
        hideManager
      />
      <UploadCSVPropertiesModal
        visible={uploaderModal}
        setVisibility={() => setUploaderModal(false)}
        getData={getData}
        attachToUser
        limitedView
      />
    </>
  )
}

export default InvitedUserLeads
